import { useQuery } from '@tanstack/react-query'
import { supabase } from '@/lib/supabase'
import { useAuth } from './useAuth'
import type { ReceivedInvitation } from '@theseus/shared-ui/orgs'

export function useReceivedInvitations() {
  const { user } = useAuth()

  const { data: invitations = [], isLoading } = useQuery({
    queryKey: ['received-invitations', user?.id],
    queryFn: async () => {
      const { data, error } = await supabase.rpc('get_my_pending_invitations')

      if (error) {
        console.error('Failed to fetch received invitations:', error)
        throw error
      }

      return (data ?? []).map((inv: {
        id: string
        org_id: string
        org_name: string
        status: string
        expires_at: string
        created_at: string
      }): ReceivedInvitation => ({
        id: inv.id,
        orgId: inv.org_id,
        orgName: inv.org_name,
        status: inv.status as ReceivedInvitation['status'],
        expiresAt: inv.expires_at,
        createdAt: inv.created_at,
      }))
    },
    enabled: !!user,
  })

  return { invitations, loading: isLoading }
}
